export const LABEL_VALIDATIONS = Object.freeze({
  REQUIRED_LABELS_NOT_AVAILABLE: 'REQUIRED_LABELS_NOT_AVAILABLE',
  NO_LABEL_AVAILABLE: 'NO_LABEL_AVAILABLE'
});
export const FETCH_URL_ERRORS = Object.freeze({
  NETWORK_ERROR: 'Network error: Please check your internet connection or the server might be down.',
  DEFAULT_ERROR: 'An unexpected error occurred.'
});
export const ERROR_TYPES = Object.freeze({
  TYPE_ERROR: 'TypeError',
  HTTP_ERROR: 'HTTP error:'
});
export const ANNOTATION_SOURCE = Object.freeze({
  YOLO: 'YOLO'
});
export const ERROR_MESSAGES = Object.freeze({
  STYLE_NOT_FOUND: (annotationTitle: string, frameIndex: number, annotationId: string) => `Unable to find style for annotation with title "${annotationTitle}". Frame: ${frameIndex}, ID: ${annotationId}. Please verify the project configuration.`
});
export const BBOX_TRACKING_ERROR_MESSAGES = Object.freeze({
  BBOX_TRACKING_FAILED: 'Failed to fetch bounding box tracking data'
});